import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import PartsCatalogEditor from "./pages/partsCatalogEditor/PartsCatalogEditor";
import ApplicationSelector from "./pages/applicationSelector/ApplicationSelector";
import AdminAccess from "./pages/adminAccess/AdminAccess";
import ProtectedRoute from "./components/ProtectedRoute";
import {
  APPLICATION_DB_EDITOR,
  APPLICATION_PARTS_CATALOG,
  canAccessApplication,
  getAccessibleApplications,
  getApplicationRoute,
  parseStoredAppRoleIds,
} from "./utils/authAccess";

function getLandingPath() {
  const isAuthenticated = localStorage.getItem("authenticated") === "true";
  if (!isAuthenticated) {
    return "/login";
  }

  const appRoleIds = parseStoredAppRoleIds(localStorage.getItem("appRoleIds"));
  const selectedApplication = localStorage.getItem("application");
  const accessibleApplications = getAccessibleApplications(appRoleIds);

  if (
    selectedApplication &&
    canAccessApplication(appRoleIds, selectedApplication)
  ) {
    return getApplicationRoute(selectedApplication);
  }

  if (accessibleApplications.length === 1) {
    return getApplicationRoute(accessibleApplications[0]);
  }

  if (accessibleApplications.length > 1) {
    return "/application-selector";
  }

  return "/login";
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to={getLandingPath()} replace />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute requiredApp={APPLICATION_DB_EDITOR}>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/parts-catalog-editor"
          element={
            <ProtectedRoute requiredApp={APPLICATION_PARTS_CATALOG}>
              <PartsCatalogEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/application-selector"
          element={
            <ProtectedRoute>
              <ApplicationSelector />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-access"
          element={
            <ProtectedRoute requireAdmin>
              <AdminAccess />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
